export default __webpack_public_path__ + "static/media/you-won-home.c67378fa.png";